import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http'
import { tap } from 'rxjs/operators'

export const getLoggerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const isGet = req.method.toUpperCase() === 'GET'
  const start = isGet ? performance.now() : 0
  if (isGet) {
    // Inicio de petición GET
    // Ej: GET https://api/example?x=1
    // Nota: Se registra aquí y al finalizar (éxito o error)
    console.log('[HTTP][GET][START]', req.urlWithParams)
  }

  return next(req).pipe(
    tap({
      next: (event: HttpEvent<unknown>) => {
        if (isGet && event instanceof HttpResponse) {
          const duration = (performance.now() - start).toFixed(0)
          console.log('[HTTP][GET][OK]', req.urlWithParams, {
            status: event.status,
            durationMs: Number(duration),
          })
        }
      },
      error: (error: any) => {
        if (isGet) {
          const duration = (performance.now() - start).toFixed(0)
          console.warn('[HTTP][GET][ERROR]', req.urlWithParams, {
            status: error?.status,
            message: error?.message,
            durationMs: Number(duration),
          })
        }
      },
    })
  )
}
